<div style="padding:0px;">
    <div mat-ripple class="card">
        <mat-card-header >
            <mat-card-title>{{title}}</mat-card-title>
            <mat-card-subtitle class="subtitle">{{subtitle}}</mat-card-subtitle>
            <mat-icon class="forward-icon">input</mat-icon>
        </mat-card-header>
    </div>
</div>